import { ConfigProvider, Grid, Input, Table } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_ENDPOINTS } from '../../assets/api/endpoints';
import './AdminUsers.scss';
import Header from '../../components/Header/Header';
import axios from 'axios';
import { SearchOutlined } from '@ant-design/icons';
import { useGetAdminUsersColumn } from '../../helpers/AdminUsersColumn';
import { AdminUser, AdminUserFilters } from '../../models/AdminUsers';
import { UserStatusModal } from '../../components/UserStatusModal/UserStatusModal';
import { UserState } from '../../models/UserState';
import { useMainContext } from '../../store/MainContext';
import { themeConfig } from '../WalletTransactions/config';
import { useConfigurationContext } from '../../store/configurationContext';
import { StyledPagination } from '../../components/table.style';

const AdminUsers = () => {
	const { t } = useTranslation();
	const { lg } = Grid.useBreakpoint();
	const { mainState } = useMainContext();
	const [adminLoading, setadminLoading] = useState(false);
	const [adminUsers, setadminUsers] = useState([]);
	const [sortBy, setSortBy] = useState<string>('name-asc');
	const [pageSize, setPageSize] = useState(10);
	const [page, setPage] = useState(0);
	const [totalElements, setTotalElements] = useState(0);
	const [user, setUser] = useState<AdminUser>();
	const [showModal, setShowModal] = useState(false);
	const [showData, setShowData] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const [filterdData, setFilteredData] = useState([]);

	useEffect(() => {
		setadminLoading(true);
		axios
			.get(`${API_ENDPOINTS.getAdminUsers}`)
			.then((res) => {
				setadminUsers(res.data);
				setFilteredData(res.data);
				setTotalElements(res.data.length);
			})
			.catch((err) => console.error(err))
			.finally(() => setadminLoading(false));
	}, [showData]);

	useEffect(() => {
		const words = searchTerm.split(' ');
		const sortedData = adminUsers
			.sort((a: any, b: any) => {
				switch (sortBy) {
					case AdminUserFilters.nameAsc:
						return a.firstname.localeCompare(b.firstname);
					case AdminUserFilters.nameDesc:
						return b.firstname.localeCompare(a.firstname);
					case AdminUserFilters.countryAsc:
						return a.countryCode.localeCompare(b.countryCode);
					case AdminUserFilters.emailAddressAsc:
						return a.email.localeCompare(b.email);
					case AdminUserFilters.emailAddressDesc:
						return b.email.localeCompare(a.email);
					case AdminUserFilters.phoneNumberAsc:
						return a.phone.localeCompare(b.phone);
					case AdminUserFilters.phoneNumberDesc:
						return b.phone.localeCompare(a.phone);
					case AdminUserFilters.roleAsc:
						return a.role.localeCompare(b.role);
					case AdminUserFilters.roleDesc:
						return b.role.localeCompare(a.role);
					case AdminUserFilters.canHandleAppealAsc:
						return a.canHandleAppeals - b.canHandleAppeals;
					case AdminUserFilters.canHandleAppealAsc:
						return b.canHandleAppeals - a.canHandleAppeals;
					case AdminUserFilters.userStatusDesc:
						return a.userStatus.localeCompare(b.userStatus);
					case AdminUserFilters.userStatusAsc:
						return b.userStatus.localeCompare(a.userStatus);
					case AdminUserFilters.createdAtAsc:
						return a.createdAt.localeCompare(b.createdAt);
					case AdminUserFilters.createdAtDesc:
						return b.createdAt.localeCompare(a.createdAt);
					default:
						return 0;
				}
			})
			.filter((user) =>
				words.every((word) => Object.values(user).some((value) => String(value).toLowerCase().includes(word))),
			);
		setFilteredData(sortedData);
	}, [sortBy, searchTerm]);

	const handleActiveState = () => {
		let state: UserState = user?.userStatus.startsWith('ACTIVE') ? 'DEACTIVATE' : 'ACTIVATE';
		let userId = `${user?.id ?? ''}`;
		axios(`${API_ENDPOINTS.performAdminUserAction.replace('%userId%', userId).replace('%action%', state)}`, {
			method: 'POST',
		})
			.then((_) => setShowData(!showData))
			.catch((err) => console.error(err));
	};

	const { configurationState } = useConfigurationContext();
	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';
	return (
		<div className='countries-and-paym-container'>
			<Header title={t<string>('admin')} description={t<string>('adminDetailsforAddEditAdmin')} />
			<div className='min-h-[84vh] mx-auto px-5 py-5 bg-white'>
				<div className='flex justify-end items-center my-2'>
					<Input
						className='border-none h-10 bg-[#F5F5F5] search-input w-[200px] xss:my-4 lg:my-0'
						placeholder={t<string>('searchAdmin')}
						value={searchTerm}
						onChange={(e) => {
							setSearchTerm(e.target.value);
						}}
						size='large'
						prefix={<SearchOutlined className='mr-2' />}
					/>
				</div>
				<ConfigProvider theme={themeConfig}>
					<StyledPagination bgColor={themeColor} color={secondary_color}>
						<Table
							columns={useGetAdminUsersColumn(t, sortBy, setSortBy, setUser, setShowModal, mainState.role, !lg)}
							dataSource={filterdData}
							pagination={{
								pageSize,
								total: totalElements,
								onChange: (pageIndex) => setPage(pageIndex - 1),
								current: page + 1,
							}}
							loading={adminLoading}
							tableLayout='fixed'
						/>
					</StyledPagination>
				</ConfigProvider>
			</div>
			{showModal && (
				<UserStatusModal
					showModal={showModal}
					setShowModal={setShowModal}
					handleUserState={handleActiveState}
					state={user?.userStatus.startsWith('ACTIVE') ? 'DEACTIVATE' : 'ACTIVATE'}
					user={''}
				/>
			)}
		</div>
	);
};

export default AdminUsers;
